import { Component } from '@angular/core';

@Component({
    selector: 'zp-plain-loader',
    templateUrl: './plain-loader.component.html',
    styleUrls: ['./plain-loader.component.scss'],
    standalone: false
})
export class PlainLoaderComponent {
}
